import { Component, OnInit } from '@angular/core';
import { GeolocationService } from '../services/geolocationservice';
import { Router } from '@angular/router';

@Component({
  selector: 'app-new-cust-card',
  templateUrl: './new-cust-card.component.html',
  styleUrls: ['./new-cust-card.component.css']
})
export class NewCustCardComponent implements OnInit {
  
  urlList: any;
  tvsmOnboardingCustUrl: any;

  constructor(private service: GeolocationService,private router: Router) { }

  ngOnInit(): void {
    
  }
  availNow(){
    this.service.getTvsmOnboardingCustUrl().subscribe((data:any)=>{
       if (typeof (data) === 'object') {
        console.log("event:" + JSON.stringify(data));
        this.urlList = JSON.parse(data.data);
         // this.tvsmOnboardingCustUrl = JSON.parse(data.tvsmOnboardingCustUrl);
        console.log("urllll"+this.urlList);
        console.log(JSON.stringify(this.urlList))
       // window.location.href= this.urlList[0].tvsmOnboardingCustUrl;
       this.router.navigate(["thank-you"]);
       if (data.statusCode == 'EX') {
        // this.loader = false;
       } else if (data.statusCode == 'SR') {
        // this.loader = false;
        }

      }
      });
  
  }

}
